// src/hooks/useGeolocation.ts
import { useState, useEffect } from 'react'

interface GeolocationData {
  country: string // ISO country code (e.g., 'IN', 'US')
  isIndia: boolean
  loading: boolean
  error: string | null
}

export const useGeolocation = (): GeolocationData => {
  // DEBUG: Force country for testing (set to null for real detection)
  const FORCE_COUNTRY: string | null = null // Change to 'US' or 'IN' for testing or null for LIVE
    
  const [data, setData] = useState<GeolocationData>({
      country: FORCE_COUNTRY || 'IN',
      isIndia: FORCE_COUNTRY ? FORCE_COUNTRY === 'IN' : true,
      loading: !FORCE_COUNTRY,
      error: null,
  })

  useEffect(() => {
    // Skip detection if country forced for testing
    if (FORCE_COUNTRY) {
        setData({
          country: FORCE_COUNTRY,
          isIndia: FORCE_COUNTRY === 'IN',
          loading: false,
          error: null,
        })
        return
    }
    const detectLocation = async () => {
      try {
        const response = await fetch('https://cloudflare.com/cdn-cgi/trace', {
          signal: AbortSignal.timeout(5000), // 5 second timeout
        })

        if (!response.ok) {
          throw new Error('Geolocation API failed')
        }
        
        const text = await response.text()
        const locMatch = text.match(/loc=([A-Z]{2})/)
        const countryCode = locMatch ? locMatch[1] : 'IN'

        setData({
          country: countryCode,
          isIndia: countryCode === 'IN',
          loading: false,
          error: null,
        })
      } catch (error) {
        console.error('Geolocation detection failed:', error)
        // Default to India on error
        setData({
          country: 'IN',
          isIndia: true,
          loading: false,
          error: 'Failed to detect location. Defaulting to India.',
        })
      }
    }

    detectLocation()
  }, [])

  return data
}